import React from 'react';
import { Box, Flex } from '@cko/primitives';
import { LoadingBlock } from '@cko/dashboard-shared';

export const LOADING_ITEM_TEST_ID = 'notifications-in-navigation-loading-notification-item';

export const LoadingItem = () => {
  return (
    <Box data-testid={LOADING_ITEM_TEST_ID} marginBottom="var(--layout-shoebox)">
      <Flex justifyContent="space-between" marginBottom="var(--layout-soybean)">
        <Box width="156px">
          <LoadingBlock />
        </Box>
        <Box width="14px">
          <LoadingBlock />
        </Box>
      </Flex>
      <Box marginBottom="var(--layout-seed)" width="331px">
        <LoadingBlock width="331px" />
      </Box>
      <Box marginBottom="var(--layout-soybean)" width="238px">
        <LoadingBlock />
      </Box>
      <Box width="172px">
        <LoadingBlock />
      </Box>
    </Box>
  );
};
